import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  FaRobot,
  FaUser,
  FaSearch,
  FaExclamationCircle,
  FaUserTie,
  FaExclamationTriangle,
  FaBan,
  FaUserPlus,
  FaTimes
} from "react-icons/fa";
import "../../css/HistorialChats.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EmojiPicker from "emoji-picker-react";
import Cookies from "universal-cookie";


const API_BASE = process.env.REACT_APP_API_BASE_URL + "/api/Chat";

const formatPrettyDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  const timeOptions = { hour: "numeric", minute: "2-digit" };

  if (isSameDay(d, now)) return `Hoy ${d.toLocaleTimeString([], timeOptions)}`;
  if (isSameDay(d, yesterday))
    return `Ayer ${d.toLocaleTimeString([], timeOptions)}`;

  // ej: 12 Oct 2025 4:25 PM
  return d.toLocaleString([], {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const HistorialChats = () => {
  const [chats, setChats] = useState([]); // raw data from API
  const [selectedSession, setSelectedSession] = useState(null);
  const [query, setQuery] = useState("");
  const [messageText, setMessageText] = useState(""); // Mensaje Input
  const [loading, setLoading] = useState(false);
  const [spamMap, setSpamMap] = useState({}); // { numero spam: true/false }
  const [spamMotivos, setSpamMotivos] = useState({});
  const [transferenciaMap, setTransferenciaMap] = useState({});
  const [transferenciaMotivos, setTransferenciaMotivos] = useState({});
  const [cursoMap, setCursoMap] = useState({});
  const [cursoMotivos, setCursoMotivos] = useState({});

  const [showPicker, setShowPicker] = useState(false); //Ver Emojis Panel
  const [estadoBtonEnviarMensaje, setEstadoBtonEnviarMensaje] = useState(false); //Ver Emojis Panel
  const [filtroEtiqueta, setFiltroEtiqueta] = useState("todos");
  const cookies = new Cookies();

  // Leer cookies directamente en el estado inicial para que ObtenerHistorialChats
  // siempre tenga los valores correctos desde el primer render y en el auto-refresh
  const [userName, setUserName]   = useState(() => cookies.get("nombreUsuario") || "");
  const [perfil,   setRol]        = useState(() => cookies.get("perfil")        || "");
  const [idUsuario, setIdUsuario] = useState(() => cookies.get("idUsuario")     || 0);

  // Modal asignación de chat (solo admin)
  const [modalAsignar, setModalAsignar] = useState(false);
  const [chatParaAsignar, setChatParaAsignar] = useState(null);
  const [usuariosAsesores, setUsuariosAsesores] = useState([]);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState("");
  const [asignacionMap, setAsignacionMap] = useState({}); // { sessionId: "Nombre Asesor" }

  // refs for scroll
  const leftListRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const firstLoad = useRef(false);


  // Obtener el historial de  chats
  // const ObtenerHistorialChats = async (silent = false) => {
  //   if (!silent) setLoading(true);

  //   try {
  //     const res = await axios.get(`${API_BASE}/ObtenerChats`);

  //     const normalized = Array.isArray(res.data)
  //       ? res.data.map((c) => {
  //         let numero = c.sessionId.split("@")[0].split(":")[0];

  //         return {
  //           sessionId: numero,
  //           nombreWhatsapp: c.nombreWhatsapp,
  //           telefonoWhatsapp: c.telefonoWhatsapp,
  //           mensajes: (c.mensajes || []).map((m) => ({
  //             id: m.id,
  //             content: m.mensaje,
  //             fechaRegistro: m.fechaMensaje,
  //             fromAgent:
  //               m.origen === "Agente IA"
  //                 ? "ai"
  //                 : m.origen === "Asesor"
  //                   ? "system"
  //                   : "human",
  //             estado: m.estado,
  //           })),
  //         };
  //       })
  //       : [];

  //     const grouped = normalized.reduce((acc, chat) => {
  //       if (!acc[chat.sessionId]) {
  //         acc[chat.sessionId] = {
  //           sessionId: chat.sessionId,
  //           nombreWhatsapp: chat.nombreWhatsapp,
  //           telefonoWhatsapp: chat.telefonoWhatsapp,
  //           mensajes: [],
  //         };
  //       }
  //       acc[chat.sessionId].mensajes = chat.mensajes;
  //       return acc;
  //     }, {});

  //     const chatsArray = Object.values(grouped);

  //     setChats(chatsArray);

  //     chatsArray.forEach((chat) => {
  //       validarSpam(chat.sessionId);
  //       validarTransferenciaHumano(chat.sessionId);
  //       validarInteresCurso(chat.sessionId);
  //     });

  //     // NO cambiar el chat seleccionado
  //     if (
  //       !selectedSession &&
  //       chatsArray.length > 0
  //     ) {
  //       setSelectedSession(chatsArray[0].sessionId);
  //     }
  //   } catch (err) {
  //     console.error("Auto-refresh error", err);
  //   } finally {
  //     if (!silent) setLoading(false);
  //   }
  // };
  const ObtenerHistorialChats = async (silent = false, forzarReemplazo = false) => {
    if (!silent) setLoading(true);

    try {
      const cookiesLocal = new Cookies();
      const perfilActual    = perfil    || cookiesLocal.get("perfil")    || "";
      const idUsuarioActual = idUsuario || cookiesLocal.get("idUsuario") || 0;

      const res = await axios.get(`${API_BASE}/ObtenerChats`, {
        params: { idUsuario: idUsuarioActual, perfil: perfilActual }
      });

      const normalized = Array.isArray(res.data)
        ? res.data.map((c) => {
          let numero = c.sessionId.split("@")[0].split(":")[0];

          return {
            sessionId: numero,
            nombreWhatsapp: c.nombreWhatsapp,
            telefonoWhatsapp: c.telefonoWhatsapp,
            mensajes: (c.mensajes || []).map((m) => ({
              id: m.id,
              content: m.mensaje,
              fechaRegistro: m.fechaMensaje,
              fromAgent:
                m.origen === "Agente IA"
                  ? "ai"
                  : m.origen === "Asesor"
                    ? "system"
                    : "human",
              estado: m.estado,
            })),
          };
        })
        : [];

      setChats((prevChats) => {
        // IDs que el backend autoriza para este usuario en este momento
        const sessionIdsAutorizados = new Set(normalized.map((c) => c.sessionId));

        // Si es refresh manual (botón) → partir de cero para quitar chats liberados
        // Si es auto-refresh silencioso → solo filtrar los autorizados
        const base = forzarReemplazo ? [] : prevChats.filter((c) => sessionIdsAutorizados.has(c.sessionId));

        const map = new Map();
        base.forEach((c) => map.set(c.sessionId, c));

        normalized.forEach((newChat) => {
          const oldChat = map.get(newChat.sessionId);

          if (!oldChat) {
            map.set(newChat.sessionId, newChat);
            // ✅ VALIDACIONES
            validarSpam(newChat.sessionId);
            validarTransferenciaHumano(newChat.sessionId);
            validarInteresCurso(newChat.sessionId);
          } else {
            // ✅ VALIDACIONES
            validarSpam(newChat.sessionId);
            validarTransferenciaHumano(newChat.sessionId);
            validarInteresCurso(newChat.sessionId);

            const oldIds = new Set(oldChat.mensajes.map((m) => m.id));
            const nuevosMensajes = newChat.mensajes.filter((m) => !oldIds.has(m.id));

            if (nuevosMensajes.length > 0) {
              map.set(newChat.sessionId, {
                ...oldChat,
                mensajes: [...oldChat.mensajes, ...nuevosMensajes],
              });
            }
          }
        });

        return Array.from(map.values());
      });

      // Si el chat activo ya no viene del backend (le quitaron la asignación) → deseleccionar
      setSelectedSession((prev) => {
        if (!prev) return normalized.length > 0 ? normalized[0].sessionId : null;
        const sigueExistiendo = normalized.some((c) => c.sessionId === prev);
        return sigueExistiendo ? prev : (normalized.length > 0 ? normalized[0].sessionId : null);
      });

    } catch (err) {
      console.error("Auto-refresh error", err);
    } finally {
      if (!silent) setLoading(false);
    }
  };



  const isNearBottom = () => {
    const el = messagesContainerRef.current;
    if (!el) return false;
    return el.scrollHeight - el.scrollTop - el.clientHeight < 120;
  };


  // Actualizar mensajes automaticamente
  useEffect(() => {
    const interval = setInterval(() => {
      if (document.activeElement === inputRef.current) return;
      ObtenerHistorialChats(true);
    }, 5000);

    return () => clearInterval(interval);
  }, [selectedSession]);



  // Funcion para validar si es spam o no
  // Función para validar si es spam o no
  const validarSpam = async (numero) => {
    try {
      const res = await axios.get(
        `${API_BASE}/ValidarTelefonoSpam/${numero}`
      );

      if (res.data?.estado === true) {
        setSpamMap((prev) => ({
          ...prev,
          [numero]: true,
        }));

        setSpamMotivos((prev) => ({
          ...prev,
          [numero]: res.data.motivoSpam || "Sin motivo registrado",
        }));
      } else {
        setSpamMap((prev) => ({
          ...prev,
          [numero]: false,
        }));
      }
    } catch (err) {
      console.error("❌ Error validando spam", err);
    }
  };


  // Funcion para validar si es transferencia a humano
  const validarTransferenciaHumano = async (numero) => {
    try {
      const res = await axios.get(
        `${API_BASE}/ValidarTelefonoTransferencia/${numero}`
      );

      if (res.data && res.data.estado === true) {
        setTransferenciaMap((prev) => ({ ...prev, [numero]: true }));
        setTransferenciaMotivos((prev) => ({
          ...prev,
          [numero]: res.data.motivoTransferencia,
        }));
      } else {
        setTransferenciaMap((prev) => ({ ...prev, [numero]: false }));
      }
    } catch (err) {
      console.error("Error validando transferencia", err);
    }
  };


  // Funcion para validar si esta interesado en Curso
  const validarInteresCurso = async (numero) => {
    try {
      const res = await axios.get(
        `${API_BASE}/ValidarInteresadoCurso/${numero}`
      );

      if (res.data && res.data.estado === true) {
        setCursoMap((prev) => ({ ...prev, [numero]: true }));
        setCursoMotivos((prev) => ({
          ...prev,
          [numero]: res.data.motivoTransferencia,
        }));
      } else {
        setCursoMap((prev) => ({ ...prev, [numero]: false }));
      }
    } catch (err) {
      console.error("Error validando curso", err);
    }
  };


  // Tomar Control de un Chat ya se la IA o un Asesor
  const tomarControl = async () => {
    if (!selectedSession) return;

    try {
      const payload = {
        numeroTelefono: selectedSession,
        motivoTransferencia: "Control tomado por asesor",
        usuarioRegistro: userName,  // <- cámbialo según tu lógica
        usuarioModificacion: userName  // <- cámbialo según tu lógica
      };

      let res;

      // Si YA está en modo asesor → devolver control a la IA
      if (transferenciaMap[selectedSession] === true) {
        res = await axios.post(`${API_BASE}/TomarControlIAWhatsApp`, payload);

        // Actualiza flags en el frontend
        setTransferenciaMap((prev) => ({ ...prev, [selectedSession]: false }));
      }
      // Si NO está en modo asesor → tomar control humano
      else {
        res = await axios.post(`${API_BASE}/TomarControlAsesorWhatsApp`, payload);

        // Actualiza flags en el frontend
        setTransferenciaMap((prev) => ({ ...prev, [selectedSession]: true }));

        validarTransferenciaHumano(selectedSession);
      }

      console.log("Respuesta:", res.data);
    } catch (err) {
      console.error("❌ Error al tomar control:", err);
    }
  };


  // Elminar SPAM de un Numero
  const eliminarSPAM = async () => {
    if (!selectedSession) return;

    try {
      const payload = {
        numeroTelefono: selectedSession,
        usuarioModificacion: userName  // <- cámbialo según tu lógica
      };

      let res;

      res = await axios.post(`${API_BASE}/EliminarTelefonoDeSpam`, payload);

      // Actualiza flags en el frontend
      setSpamMap((prev) => ({ ...prev, [selectedSession]: false }));
      validarSpam(selectedSession);

      console.log("Respuesta:", res.data);
    } catch (err) {
      console.error("❌ Error al tomar control:", err);
    }
  };


  // Marcar como SPAM
  const marcarComoSPAM = async () => {
    if (!selectedSession) return;

    try {
      const payload = {
        numeroTelefono: selectedSession,
        motivoSpam: "Asesor marca como SPAM",
        usuarioRegistro: userName // cámbialo si usas cookies o usuario logueado
      };

      const res = await axios.post(`${API_BASE}/InsertarTelefonoSpam`, payload);

      // Actualizar flags en el frontend
      setSpamMap((prev) => ({ ...prev, [selectedSession]: true }));
      validarSpam(selectedSession);

      console.log("Respuesta:", res.data);
    } catch (err) {
      console.error("❌ Error al marcar como SPAM:", err);
    }
  };


  // Carga inicial
  useEffect(() => {
    if (firstLoad.current) return;
    firstLoad.current = true;

    if (perfil.toLowerCase() === "administrador") {
      cargarAsignaciones();
    }

    ObtenerHistorialChats();
  }, []);


  // Filtra en todas las coversaciones las coincidencias segun los filtros indicados 
  const filtrarChats = chats.filter(chat => {
    // --- FILTRO POR ETIQUETA ---
    if (filtroEtiqueta !== "todos") {
      if (filtroEtiqueta === "spam" && !spamMap[chat.sessionId]) return false;
      if (filtroEtiqueta === "asesor" && !transferenciaMap[chat.sessionId]) return false;
      if (filtroEtiqueta === "curso" && !cursoMap[chat.sessionId]) return false;
    }

    // --- FILTRO POR BUSCADOR ---
    if (query.trim()) {
      const q = query.trim().toLowerCase();

      const lastMsg = chat.mensajes?.length
        ? chat.mensajes[chat.mensajes.length - 1].content.toLowerCase()
        : "";
      const number = chat.sessionId.toLowerCase();
      if (!number.includes(q) && !lastMsg.includes(q)) return false;
    }

    return true;
  });

  // Cuanso se aplique un filtro de chat validar si el que esta seleccionado se encuentra en el historial de busqueda
  // o se deja seleccioando por defecto el primero que encuentra
  useEffect(() => {
    if (!filtrarChats.length) {
      // No hay chats en el filtro → deseleccionar
      setSelectedSession(null);
      return;
    }

    // Si el chat seleccionado no está en la lista filtrada → cambiarlo
    const existe = filtrarChats.some(
      (chat) => chat.sessionId === selectedSession
    );

    if (!existe) {
      setSelectedSession(filtrarChats[0].sessionId);
    }
  }, [filtrarChats]);


  //Para que no se mueva el scroll
  useEffect(() => {
    const el = messagesContainerRef.current;
    if (!el) return;

    if (isNearBottom()) {
      el.scrollTop = el.scrollHeight;
    }
  }, [chats]);

  // auto-scroll to bottom when selectedSession or chats change
  // useEffect(() => {
  //   const el = messagesContainerRef.current;
  //   if (!el) return;
  //   // small delay to ensure DOM updated
  //   const t = setTimeout(() => {
  //     el.scrollTop = el.scrollHeight;
  //   }, 60);
  //   return () => clearTimeout(t);
  // }, [selectedSession, chats]);

  // helper to add a local message (optimistic)
  const addLocalMessage = (sessionId, msg) => {
    setChats((prev) => {
      // find chat
      const found = prev.find((c) => c.sessionId === sessionId);
      if (found) {
        return prev.map((c) =>
          c.sessionId === sessionId
            ? { ...c, mensajes: [...c.mensajes, msg] }
            : c
        );
      } else {
        // create new conversation
        return [...prev, { sessionId, mensajes: [msg] }];
      }
    });
  };
  const inputRef = useRef(null);


  // Función para agregar emoji al texto
  const onEmojiClick = (emojiData, event) => {
    const input = inputRef.current;
    if (!input) return; // <--- Evita el error si input es null

    const start = input.selectionStart;
    const end = input.selectionEnd;

    const newText =
      messageText.substring(0, start) +
      emojiData.emoji +
      messageText.substring(end);

    setMessageText(newText);

    // Colocar cursor después del emoji insertado
    setTimeout(() => {
      input.focus();
      input.setSelectionRange(
        start + emojiData.emoji.length,
        start + emojiData.emoji.length
      );
    }, 0);

    setShowPicker(false); // Oculta panel después de seleccionar
  };


  // Función para enviar un mensaje desde el agente
  const EnviarMensajeWhat = async () => {
    // 1. Quitamos espacios y validamos que haya texto y chat seleccionado
    const text = messageText.trim();
    if (!text || !selectedSession) return;

    // 2. Creamos un ID temporal para el mensaje mientras se envía al backend
    //    Esto permite a React identificarlo y actualizar su estado después.
    const tempId = `temp-${Date.now()}`;

    // 3. Creamos el mensaje local que se mostrará en pantalla de inmediato.
    //    __status controla cómo se va a mostrar (pending, sent, error)
    const newMsg = {
      fromAgent: "system", // Lo ubica a la derecha en el chat
      content: messageText, // Texto real del mensaje
      fechaRegistro: new Date().toISOString(), // Hora local del front
      __tempId: tempId, // ID temporal mientras se envía
      __status: "pending", // Estado visual: "pendiente de enviar"
    };

    // 4. Agregamos el mensaje inmediatamente en el chat sin esperar API
    //    Esto hace que se vea instantáneo (igual que WhatsApp Web)
    addLocalMessage(selectedSession, newMsg);

    // 5. Limpiamos la caja de texto
    setMessageText("");

    try {
      // 6. Llamamos al backend para enviar el mensaje real por WhatsApp
      await axios.post(`${API_BASE}/EnviarMensajeWhatsApp`, {
        telefono: selectedSession, // Número de la sesión
        mensaje: messageText, // Puede incluir emoji
        asesorWeb: userName
      });

      // 7. Si el backend responde OK → marcamos el mensaje como enviado
      setChats((prev) =>
        prev.map((c) => {
          if (c.sessionId !== selectedSession) return c;

          return {
            ...c,
            mensajes: c.mensajes.map((m) =>
              m.__tempId === tempId
                ? { ...m, __status: "sent", __tempId: undefined } // éxito
                : m
            ),
          };
        })
      );
    } catch (err) {
      console.error("Error al enviar mensaje", err);

      // 8. Si la API falla → marcamos el mensaje como ERROR
      //    Esto permite que en la UI se muestre un botón "Reintentar"
      setChats((prev) =>
        prev.map((c) => {
          if (c.sessionId !== selectedSession) return c;

          return {
            ...c,
            mensajes: c.mensajes.map((m) =>
              m.__tempId === tempId
                ? { ...m, __status: "error" } // Marcado como fallido
                : m
            ),
          };
        })
      );
    }
  };

  // utility to display last message preview
  const lastPreview = (chat) => {
    const last =
      chat.mensajes && chat.mensajes.length
        ? chat.mensajes[chat.mensajes.length - 1].content
        : "";
    return last.length > 40 ? last.slice(0, 40) + "..." : last;
  };


  const chatsFiltrados = chats.filter(c => {
    if (filtroEtiqueta === "todos") return true;
    if (filtroEtiqueta === "spam") return spamMap[c.sessionId] === true;
    if (filtroEtiqueta === "asesor") return transferenciaMap[c.sessionId] === true;
    if (filtroEtiqueta === "curso") return cursoMap[c.sessionId] === true;

    return true;
  });


  // ── Cargar asignaciones activas de todos los chats (solo admin) ───────────
  const cargarAsignaciones = async () => {
    try {
      const res = await axios.get(`${API_BASE}/ObtenerAsignaciones`);
      const lista = res.data?.data || res.data || [];
      // Construir mapa { sessionId: "Nombres Apellidos (usuario)" }
      const mapa = {};
      lista.forEach((a) => {
        mapa[a.sessionId] = a.nombresApellidos
          ? `${a.nombresApellidos} (${a.nombreUsuario})`
          : a.nombreUsuario;
      });
      setAsignacionMap(mapa);
    } catch (err) {
      console.error("Error cargando asignaciones:", err);
    }
  };

  // ── Cargar lista de asesores (usuarios no admin) para el modal ─────────────
  const cargarUsuariosAsesores = async () => {
    try {
      const baseURL = process.env.REACT_APP_API_BASE_URL;
      const res = await axios.get(`${baseURL}/api/Usuarios/ObtenerUsuarios`);
      // La API devuelve { exito, mensaje, data: [...] }
      const lista = res.data?.data || res.data || [];
      // Filtrar activos y no administradores (cubre "Estándar", "Estandar", etc)
      const asesores = lista.filter((u) => {
        if (!u.estado) return false;
        const p = (u.perfil || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return p !== "administrador";
      });
      setUsuariosAsesores(asesores);
    } catch (err) {
      console.error("Error cargando asesores:", err);
    }
  };

  // ── Abrir modal de asignación ───────────────────────────────────────────────
  const abrirModalAsignar = async (chat, e) => {
    e.stopPropagation();
    setChatParaAsignar(chat);
    setUsuarioSeleccionado("");
    await cargarUsuariosAsesores();
    setModalAsignar(true);
  };

  // ── Confirmar asignación ────────────────────────────────────────────────────
  const confirmarAsignacion = async () => {
    if (!usuarioSeleccionado) {
      toast.warning("Selecciona un asesor para asignar.", { position: "top-right", autoClose: 3000 });
      return;
    }
    try {
      await axios.post(`${API_BASE}/AsignarChat`, {
        sessionId:       chatParaAsignar.sessionId,
        idUsuario:       parseInt(usuarioSeleccionado),
        usuarioRegistro: userName,
      });
      toast.success("Chat asignado correctamente.", { position: "top-right", autoClose: 3000 });
      setModalAsignar(false);
      cargarAsignaciones(); // refrescar quién está asignado a cada chat
    } catch (err) {
      console.error("Error al asignar chat:", err);
      toast.error("Error al asignar el chat.", { position: "top-right", autoClose: 3000 });
    }
  };

  // ── Liberar chat (quitar asesor asignado) ─────────────────────────────────
  const liberarChat = async (chat, e) => {
    e.stopPropagation();
    try {
      await axios.post(`${API_BASE}/DesasignarChat`, {
        sessionId:            chat.sessionId,
        usuarioModificacion:  userName,
      });
      toast.success("Chat liberado correctamente.", { position: "top-right", autoClose: 3000 });
      cargarAsignaciones();
    } catch (err) {
      console.error("Error al liberar chat:", err);
      toast.error("Error al liberar el chat.", { position: "top-right", autoClose: 3000 });
    }
  };

  const esAdmin = perfil?.toLowerCase() === "administrador";

  // render
  return (
    <div className="historial-chats-container">
      {/* --- SIDEBAR --- */}
      <div className="chat-sidebar">
        {/* Header: Title + Actions */}
        <div className="sidebar-header">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="sidebar-title">Chats</h3>
            <button
              className="btn btn-sm btn-light"
              onClick={() => { ObtenerHistorialChats(false, true); if (esAdmin) cargarAsignaciones(); }}
              title="Actualizar lista"
              style={{ color: "var(--primary-color)" }}
            >
              <i className="fas fa-sync-alt" />
            </button>
          </div>

          {/* Filters */}
          <div className="d-flex gap-2">
            <select
              className="form-control form-control-sm"
              value={filtroEtiqueta}
              onChange={(e) => setFiltroEtiqueta(e.target.value)}
              style={{ borderRadius: "8px", height: "39px" }}
            >
              <option value="todos">Todos</option>
              <option value="spam">Spam</option>
              <option value="asesor">Asesor</option>
              <option value="curso">Curso</option>
            </select>
          </div>

          {/* Search */}
          <div className="sidebar-search">
            <span className="search-icon-pos">
              <FaSearch />
            </span>
            <input
              placeholder="Buscar por número o mensaje..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
        </div>

        {/* List */}
        <div className="virtual-scroll-container" ref={leftListRef}>
          {loading && (
            <div className="p-3 text-center text-muted">
              <i className="fas fa-spinner fa-spin mr-2"></i> Cargando...
            </div>
          )}

          {filtrarChats.length === 0 && !loading && (
            <div className="p-4 text-center text-muted">
              No se encontraron chats
            </div>
          )}

          {filtrarChats.map((chat) => {
            const last =
              chat.mensajes && chat.mensajes.length
                ? chat.mensajes[chat.mensajes.length - 1]
                : null;

            // Determine avatar style
            const isAI = last && last.fromAgent === "ai";
            const isSystem = last && last.fromAgent === "system";
            const avatarClass = isAI
              ? "avatar-circle avatar-robot"
              : isSystem
                ? "avatar-circle avatar-agent"
                : "avatar-circle avatar-user";

            const isActive = selectedSession === chat.sessionId;

            return (
              <div
                key={chat.sessionId}
                className={`chat-list-item ${isActive ? "active" : ""}`}
                onClick={() => setSelectedSession(chat.sessionId)}
              >
                <div className={avatarClass}>
                  {isAI ? <FaRobot size={20} /> : isSystem ? <FaUserTie size={20} /> : <FaUser size={20} />}
                </div>

                <div className="chat-info">
                  <div className="chat-header-row">
                    <span className="chat-name">
                      {chat.nombreWhatsapp || "Desconocido"}
                      <span style={{ fontSize: "0.85em", fontWeight: "normal", color: "#888", marginLeft: 6 }}>
                        ({chat.telefonoWhatsapp || chat.sessionId})
                      </span>
                    </span>
                    <span className="chat-date">
                      {last ? formatPrettyDate(last.fechaRegistro) : ""}
                    </span>
                  </div>

                  {/* Asesor asignado + Botones admin */}
                  {esAdmin && (
                    <div className="admin-chat-row">
                      {asignacionMap[chat.sessionId] ? (
                        <>
                          <span className="badge-asesor-asignado">
                            <FaUserTie size={9} />
                            {asignacionMap[chat.sessionId]}
                          </span>
                          <div className="admin-chat-actions">
                            <button
                              className="btn-chat-action btn-reasignar"
                              onClick={(e) => abrirModalAsignar(chat, e)}
                              title="Reasignar a otro asesor"
                            >
                              <FaUserPlus size={9} /> Reasignar
                            </button>
                            <button
                              className="btn-chat-action btn-liberar"
                              onClick={(e) => liberarChat(chat, e)}
                              title="Liberar chat (quitar asesor)"
                            >
                              <FaTimes size={9} /> Liberar
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <span className="badge-sin-asignar">Sin asignar</span>
                          <button
                            className="btn-chat-action btn-asignar"
                            onClick={(e) => abrirModalAsignar(chat, e)}
                            title="Asignar a un asesor"
                          >
                            <FaUserPlus size={9} /> Asignar
                          </button>
                        </>
                      )}
                    </div>
                  )}

                  <div className="chat-preview-row" style={{ minHeight: 24 }}>
                    <span
                      className="chat-message-preview"
                      style={{ marginRight: 8, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                      {lastPreview(chat)}
                    </span>

                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      {/* Badges indicators */}
                      {spamMap[chat.sessionId] && (
                        <span
                          className="badge-pill badge-spam"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toast.error(
                              spamMotivos[chat.sessionId] || "Sin motivo registrado",
                              { position: "top-right", autoClose: 4000 }
                            );
                          }}
                        >
                          SPAM
                        </span>
                      )}
                      {transferenciaMap[chat.sessionId] && (
                        <span
                          className="badge-pill badge-agent"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toast.info(
                              transferenciaMotivos[chat.sessionId] || "Sin motivo registrado",
                              { position: "top-right", autoClose: 4000 }
                            );
                          }}
                        >
                          ASESOR
                        </span>
                      )}
                      {cursoMap[chat.sessionId] && (
                        <span
                          className="badge-pill badge-card"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toast.success(
                              cursoMotivos[chat.sessionId] || "Sin motivo registrado",
                              { position: "top-right", autoClose: 4000 }
                            );
                          }}
                        >
                          CURSO
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* --- RIGHT: CHAT WINDOW --- */}
      <div className="chat-window">
        {/* Background Doodle */}
        <div className="chat-bg-doodle" />

        {/* Header */}
        <div className="chat-header">
          {selectedSession ? (
            <>
              <div className="chat-header-info">
                <div className="chat-header-avatar">
                  <FaUser size={20} />
                </div>
                <div className="chat-header-text">
                  <h4>{chats.find(c => c.sessionId === selectedSession)?.nombreWhatsapp || selectedSession}</h4>
                  <span>
                    {(() => {
                      const chat = chats.find((c) => c.sessionId === selectedSession);
                      const len = chat?.mensajes?.length || 0;
                      return len > 0 ? `${len} mensajes` : "Chat vacío";
                    })()}
                  </span>
                </div>
              </div>

              <div className="chat-actions">
                {/* Spam Button */}
                <button
                  className={`action-btn ${spamMap[selectedSession] ? 'btn-spam' : ''}`}
                  onClick={spamMap[selectedSession] ? eliminarSPAM : marcarComoSPAM}
                >
                  {spamMap[selectedSession] ? <FaBan /> : <FaExclamationTriangle />}
                  {spamMap[selectedSession] ? "No es Spam" : "Spam"}
                </button>

                {/* Control Button */}
                <button
                  className={`action-btn btn-control`}
                  onClick={tomarControl}
                  style={transferenciaMap[selectedSession] ? { background: '#e1f0fa' } : {}}
                >
                  {transferenciaMap[selectedSession] ? <FaRobot /> : <FaUserTie />}
                  {transferenciaMap[selectedSession] ? "Devolver a IA" : "Tomar Control"}
                </button>
              </div>
            </>
          ) : (
            <div className="text-muted">Seleccione un chat</div>
          )}
        </div>

        {/* Messages */}
        <div className="messages-area" ref={messagesContainerRef}>
          {!selectedSession && (
            <div className="empty-state">
              <FaRobot size={48} style={{ marginBottom: 16, opacity: 0.5 }} />
              <h3>Bienvenido al Historial de Chats</h3>
              <p>Selecciona una conversación para ver los detalles.</p>
            </div>
          )}

          {selectedSession && (
            (chats.find((c) => c.sessionId === selectedSession)?.mensajes || []).map((msg, idx) => {
              const from = msg.fromAgent;
              // Logic for bubbles
              const isUser = from === 'human';
              const isAI = from === 'ai';
              const isSystem = from === 'system'; // 'Asesor' in logic sometimes map to system, check logic lines 
              // Line 92: m.origen === "Asesor" ? "system"

              // We want: 
              // User -> Left, White
              // AI/Asesor -> Right, Green/Blue

              // BUT: The original code said: 
              // const alignRight = isAI || isAsesor;
              // So "System" (Asesor) is also Right.

              let rowClass = "received"; // default left
              let bubbleClass = "received";

              if (isAI || isSystem) {
                rowClass = "sent";
                bubbleClass = "sent";
              }

              // Special system messages (like "Transferencia iniciada") could be centered?
              // For now, let's treat "Asesor" messages as normal messages from the agent side.
              // Only if the content implies a system event we might use .system class, but we don't have that distinction clearly in props.

              return (
                <div key={idx} className={`message-row ${rowClass} animate-fade-in`}>
                  <div className={`message-bubble ${bubbleClass}`}>
                    {/* If it's a system message, maybe show a tiny icon? */}
                    {isSystem && <FaUserTie size={10} style={{ marginRight: 4, opacity: 0.7 }} />}
                    {isAI && <FaRobot size={10} style={{ marginRight: 4, opacity: 0.7 }} />}

                    <span style={{ whiteSpace: 'pre-wrap' }}>{msg.content}</span>

                    <div className="msg-meta">
                      {msg.estado && <span>{msg.estado}</span>}
                      <span>{formatPrettyDate(msg.fechaRegistro)}</span>
                      {/* Status checks */}
                      {msg.__status === "pending" && <i className="far fa-clock"></i>}
                      {msg.__status === "sent" && <i className="fas fa-check"></i>}
                      {msg.__status === "error" && <i className="fas fa-exclamation-circle text-danger"></i>}
                    </div>
                  </div>
                </div>
              )
            })
          )}
        </div>

        {/* Input */}
        {selectedSession && (
          <div className="input-area">
            <button className="btn-emoji" onClick={() => setShowPicker(!showPicker)}>
              😄
            </button>
            {showPicker && (
              <div style={{ position: "absolute", bottom: 70, left: 20, zIndex: 10 }}>
                <EmojiPicker onEmojiClick={onEmojiClick} />
                {/* Close overlay */}
                <div
                  style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: -1 }}
                  onClick={() => setShowPicker(false)}
                />
              </div>
            )}

            <input
              ref={inputRef}
              className="input-message"
              placeholder="Escribe un mensaje..."
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && EnviarMensajeWhat()}
              disabled={transferenciaMap[selectedSession] === false} // Disabled if NOT in asesor mode? logic was: disabled={transferenciaMap[...] == false} -> so if map is false (AI mode), input is disabled. Correct.
            />

            <button
              className="btn-send"
              onClick={EnviarMensajeWhat}
              disabled={transferenciaMap[selectedSession] === false}
            >
              <i className="fas fa-paper-plane"></i>
            </button>
          </div>
        )}

      </div>

      <ToastContainer />

      {/* ── MODAL ASIGNAR CHAT (solo admin) ─────────────────────────────── */}
      {modalAsignar && (
        <div
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
            zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center"
          }}
          onClick={() => setModalAsignar(false)}
        >
          <div
            style={{
              background: "#fff", borderRadius: 12, padding: "28px 32px",
              minWidth: 360, maxWidth: 460, boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              position: "relative"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Cerrar */}
            <button
              onClick={() => setModalAsignar(false)}
              style={{
                position: "absolute", top: 12, right: 14,
                background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#888"
              }}
            >
              <FaTimes />
            </button>

            <h5 style={{ marginBottom: 6, fontWeight: 700 }}>
              <FaUserPlus style={{ marginRight: 8, color: "var(--primary-color)" }} />
              Asignar chat
            </h5>
            <p style={{ color: "#888", fontSize: "0.85em", marginBottom: 18 }}>
              <strong>{chatParaAsignar?.nombreWhatsapp || chatParaAsignar?.sessionId}</strong>
              <span style={{ marginLeft: 6, color: "#aaa" }}>
                ({chatParaAsignar?.telefonoWhatsapp || chatParaAsignar?.sessionId})
              </span>
            </p>

            <label style={{ fontWeight: 600, marginBottom: 6, display: "block" }}>
              Selecciona el asesor
            </label>
            <select
              className="form-control"
              value={usuarioSeleccionado}
              onChange={(e) => setUsuarioSeleccionado(e.target.value)}
              style={{ borderRadius: 8, marginBottom: 20, height:43 }}
            >
              <option value="">-- Elige un asesor --</option>
              {usuariosAsesores.map((u) => (
                <option key={u.id || u.idUsuario} value={u.id || u.idUsuario}>
                  {u.nombresApellidos} ({u.nombreUsuario})
                </option>
              ))}
            </select>

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setModalAsignar(false)}
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={confirmarAsignacion}
                disabled={!usuarioSeleccionado}
              >
                <FaUserPlus style={{ marginRight: 6 }} />
                Confirmar asignación
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HistorialChats;